import './main.less';
export default {
    computed: {
        layout() {
            return (this.$route.meta.layout || 'default') + '-layout';
        },
    },
    components: {
        'default-layout': { template: '<v-app><router-view></router-view></v-app>' },
        'blank-layout': { template: '<router-view></router-view>' },
    },
};
